



































































































































































































import { Component, Ref, Prop } from "vue-property-decorator";
import ClientDataSectionDialogComponent from "./ClientDataSectionDialog.vue";
import {
  ApprovalResult,
  ProjectDetails,
  VisibilityRestriction,
  ProjectNameSource,
  ExtendedProjectNameSource,
  ProjectTypeConfig,
  getDefaultProjectTypes,
  formatProjectTypeName,
  ProjectOperationSource,
  ExtendedProjectType,
  ExtendedVisibilityRestriction,
  isPortalOnlyProjectTypeId,
  isPortalOnlyProject,
  isDryingOnlyProjectTypeId,
  doesProjectTypeIdHaveLeakDetection,
  getProjectTypeIdOfProject,
} from "@/data/models/ProjectDetails";
import DatePickerCompoment from "@/components/common/DatePicker.vue";
import TimePickerComponent from "@/components/common/TimePicker.vue";
import ConfirmationDialogComponent from "@/components/common/ConfirmationDialog.vue";
import {
  doesClientHaveApp,
  findBranch,
  getProjectManagement,
  hasClientEnabledStrictBranchFilters,
  isExternalSystem,
  syncsProjectWithErp,
} from "@/data/repository/ClientRepository";
import { UserModule } from "@/store/modules/UserModule";
import { formatDateShort, formatTime } from "@/utils/DateFormatter";

import {
  doesOtherProjectWithProjectNumberExist,
  doesOtherProjectWithProjectNameExist,
  ProjectType,
isLeakDetectionProject,
} from "@/data/repository/ProjectRepository";
import { getBranchesVisibleToActiveUser, getRecordInfo } from "@/data/repository/UserRepository";

import PickerDialogComponent from "@/components/common/PickerDialog.vue";
import { getBranchName } from "@/data/models/Branch";
import { ProjectManagement } from "@/data/models/Client";
import { ProjectStatusData } from "@/data/models/ProjectStatusData";
import { firestore } from "firebase";
import { alwaysAllowedToEditProjectAccess, defineProjectAppVersionVisibilityAccess, specialRightsForProjectTypeSelectionAccess } from "@/permissions/UserPermissions";
import { ProjectManagementSettingsModule } from "@/store/modules/ProjectManagementSettingsModule";
import { getEffectiveUser } from "@/utils/ViewAs";
import { canEditProjectSection, isProjectSectionLocked } from "@/utils/ProjectSectionEditLock";

@Component({
  components: {
    "confirmation-dialog": ConfirmationDialogComponent,
    "date-picker": DatePickerCompoment,
    "time-picker": TimePickerComponent,
    picker: PickerDialogComponent,
  },
})
export default class ProjectSectionComponent extends ClientDataSectionDialogComponent {
  @Ref("confirm")
  confirmationDialogComponent!: ConfirmationDialogComponent;

  @Prop()
  isNewProject!: boolean;

  @Prop({ default: null })
  projectStatus!: ProjectStatusData | null;

  @Prop({ default: null })
  earliestAssignmentDate!: firestore.Timestamp | null;

  /** Max project start date: today, or earliest assignment date if it's earlier. */
  get maxProjectStartDate(): firestore.Timestamp {
    const today = firestore.Timestamp.fromDate(new Date());
    if (this.earliestAssignmentDate && this.earliestAssignmentDate.toMillis() < today.toMillis()) {
      return this.earliestAssignmentDate;
    }
    return today;
  }

  projectManagement = getProjectManagement();

  directOrder = "0";

  isEditMode = false;

  // Snapshot values for unsaved-changes detection
  snapshotProjectName = "";
  snapshotProjectNumber = "";
  snapshotProjectNameErp = "";
  snapshotDirectOrder = "0";
  snapshotBranch: string | null = null;
  snapshotProjectTypeId: number | null = null;
  snapshotProjectStartDate: firestore.Timestamp | null = null;

  /** The user whose view this shows: the chosen one while "Sicht auf" is active (ticket 2610052). */
  get activeUser() {
    return getEffectiveUser();
  }

  doesCurrectUserHaveSpecialRightsForProjectTypeSelection() {
    return specialRightsForProjectTypeSelectionAccess(this.activeUser);
  }

  get isAlwaysAllowedToEditProject() {
    return alwaysAllowedToEditProjectAccess(this.activeUser);
  }

  /** Whether BEARBEITEN is offered: a locked section leaves nothing editable without the override. */
  get canEdit() {
    return canEditProjectSection(this.disableAllOptions, this.isAlwaysAllowedToEditProject);
  }
    
  showDryingAndLeakDetectionOptions =
    this.projectManagement !== ProjectManagement.WEBSITE;


  get areCheckBoxesReadOnly() {
    return this.projectManagement === ProjectManagement.WEBSITE || this.disableAllOptions;
  }
  
  get closeButtonText() {
    return this.$t("common.abort").toString();
  }

  projectStartDate: firestore.Timestamp | null = null;

  initialProjectName: string | undefined = undefined;
  userManuallyEditedProjectName = false;
  initialProjectStartDate: firestore.Timestamp | null = null;
  initialProjectType = 0;

  projectNumberErrorMsg = "";
  showProjectNumberError = false;

  isExternalSystem = isExternalSystem();
  syncsProjectWithErp = syncsProjectWithErp();

  showAcceptImportedProjectOptions = false;
  showProjectApprovalDecisionOptions = true;

  disableAllOptions = false;

  stepIndicesToCheckForApprovalDecision = [2, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18];

  strictBranchFilters = hasClientEnabledStrictBranchFilters();
  canChangeBranch = !this.strictBranchFilters || this.branchOptions.length > 1;

  branch: string | null = null;

  projectTypeId: number | null = null;
  initialProjectTypeId: number | null = null;

  showBranchPicker = this.branchOptions.length > 0 || this.strictBranchFilters;

  get projectManagementSettings() {
    return ProjectManagementSettingsModule.projectManagementSettings;
  }

  get unfilteredProjectTypes() {
    const fromStore = this.projectManagementSettings;
    const loaded: ProjectTypeConfig[] | undefined = fromStore && fromStore.projectTypes;
    const base = JSON.parse(JSON.stringify(getDefaultProjectTypes())) as ProjectTypeConfig[];

    if (loaded && Array.isArray(loaded)) {
      const map = new Map<number, ProjectTypeConfig>(loaded.map(p => [p.projectTypeId, p]));
      return base.map(p => {
        const saved = map.get(p.projectTypeId);
        return saved ? { ...p, ...saved } : p;
      });
    } else {
      return base;
    }
  }

  get projectTypes() {
    return this.unfilteredProjectTypes
      .filter(t => t.active);
  }

  get projectTypesOptions() {
    return this.projectTypes.map((type) => type.projectTypeId)
  }

  get disableProjectTypeSelection() {
    return this.projectTypes.length === 1;
  }

  get branchOptions() {
    return getBranchesVisibleToActiveUser().map((branch) => branch.id);
  }

  get branchFormatter() {
    return (branchId: string) => {
      return getBranchName(findBranch(branchId));
    };
  }

  get projectTypeFormatter() {
    return (projectTypeId: number) => {
      return formatProjectTypeName(this, projectTypeId, this.unfilteredProjectTypes);
    }
  }

  get showProjectCreatedWithInfo() {
    return this.projectCreatedWithAppVersion && defineProjectAppVersionVisibilityAccess(this.activeUser);
  }

  get projectCreatedWithAppVersion() {
    return this.projectDetails.createdWithAppVersion;
  }

  get isSaveEnabled() {
    if (this.strictBranchFilters && !this.branch) {
      return false;
    }

    return this.projectTypes.length > 0 && this.projectTypeId && (!this.disableAllOptions || this.isAlwaysAllowedToEditProject);
  }

  get hasUnsavedChanges() {
    if (!this.isSaveEnabled) {
      return false;
    }

    if (this.isNewProject) {
      return true;
    }

    if (this.userManuallyEditedProjectName) {
      return true;
    }
    if ((this.projectDetails.clientData.projectNumber ?? "") !== this.snapshotProjectNumber) {
      return true;
    }
    if ((this.projectDetails.clientData.projectNameErp ?? "") !== this.snapshotProjectNameErp) {
      return true;
    }
    if (this.directOrder !== this.snapshotDirectOrder) {
      return true;
    }
    if (this.branch !== this.snapshotBranch) {
      return true;
    }
    if (this.projectTypeId !== this.snapshotProjectTypeId) {
      return true;
    }
    if (this.projectStartDate !== this.snapshotProjectStartDate) {
      if (!this.projectStartDate || !this.snapshotProjectStartDate) {
        return true;
      }
      if (!this.projectStartDate.isEqual(this.snapshotProjectStartDate)) {
        return true;
      }
    }

    return false;
  }
 
  get allowedToEditProjectNumberOffice() {
    return this.isExternalSystem || !this.syncsProjectWithErp;
  }

  get doesClientHaveApp() {
    return doesClientHaveApp();
  }

  get showProjectNumberIres() {
    return !!this.projectDetails.clientData?.projectNumberIres;
  }



  get startedBy() {
    return this.projectDetails.clientData.startedBy;
  }

  get startedByNickname() {
    return UserModule.userNicknameFromRecordInfo(this.startedBy);
  }

  get startedByTime() {
    const date = this.startedBy?.recordedAt;

    if (date) {
      return formatTime(date);
    } else {
      return null;
    }
  }

  get startedByDate() {
    const date = this.startedBy?.recordedAt;

    if (date) {
      return formatDateShort(date);
    } else {
      return null;
    }
  }
  
  get hasDryingLicence() {
    return UserModule.hasActiveUserDryingProjectLicence;
  }

  get hasDamageAssessmentAndLeakDetectionLicence() {
    return UserModule.hasActiveUserLeakDetectionProjectLicence;
  }

  async show(projectDetails: ProjectDetails) {
    this.projectDetails = projectDetails;
    this.initialProjectName = projectDetails.clientData.projectName;
    this.userManuallyEditedProjectName = false;
    this.directOrder = projectDetails.clientData.directOrder ? "1" : "0";
    this.showProjectNumberError = false;

    this.projectStartDate = projectDetails.clientData.projectStartDate;
    this.initialProjectStartDate = this.projectStartDate;

    // For new projects, start in edit mode; for existing, start in view mode
    this.isEditMode = this.isNewProject;

    if (isPortalOnlyProject(projectDetails)) {
      this.initialProjectType = 1
    }

    if (this.isNewProject) {
      if (this.strictBranchFilters && this.branchOptions.length === 1) {
        //If strict branch filters are enabled and client has only one branch
        //set it as the branch of this project
        this.branch = this.branchOptions[0];
      }

      if (this.projectTypes.length === 1) {
        this.projectTypeId = this.projectTypes[0].projectTypeId;
      }
    } else {
      this.branch = projectDetails.clientData.branch ?? null;
    }

    const projectTypeId = getProjectTypeIdOfProject(projectDetails);

    if (projectTypeId !== 0) {
      this.projectTypeId = projectTypeId;
    }

    this.initialProjectTypeId = this.projectTypeId;

    // Take snapshot for unsaved-changes detection
    this.takeSnapshot();

    this.showAcceptImportedProjectOptions =
      projectDetails.clientData.projectApproval?.approvalResult !==
        ApprovalResult.APPROVED && !!projectDetails.syncTarget;
        
    this.showProjectApprovalDecisionOptions = !this.stepIndicesToCheckForApprovalDecision.some(
      (index) => !!this.projectStatus?.projectSteps[index.toString()]
    );

    // Assigned on every show, so a lock from an earlier opening of this dialog never carries over.
    this.disableAllOptions =
      !this.isNewProject && isProjectSectionLocked(this.projectStatus?.projectSteps, isLeakDetectionProject(projectDetails.id));

    return this.showDialog(
      this.$t(
        this.isNewProject
          ? "clientData.newOrder"
          : this.showProjectApprovalDecisionOptions
            ? "clientData.confirmProjectTitle"
            : "common.project"
      ).toString(),
      projectDetails
    );
  }

  /**
   * An existing project gets the view / edit title pair ("Projekt", "Projekt bearbeiten"); a new
   * order and the approval prompt keep their own titles, which already say what the dialog is for.
   */
  get sectionTitle(): string {
    return this.isNewProject || this.showProjectApprovalDecisionOptions ? this.title : this.displayTitle;
  }

  /** Project section uses isNewProject to control edit mode; always report data as present. */
  hasInitialData(): boolean {
    return !this.isNewProject;
  }

  takeSnapshot() {
    this.snapshotProjectName = this.projectDetails.clientData.projectName ?? "";
    this.snapshotProjectNumber = this.projectDetails.clientData.projectNumber ?? "";
    this.snapshotProjectNameErp = this.projectDetails.clientData.projectNameErp ?? "";
    this.snapshotDirectOrder = this.directOrder;
    this.snapshotBranch = this.branch;
    this.snapshotProjectTypeId = this.projectTypeId;
    this.snapshotProjectStartDate = this.projectStartDate;
  }

  restoreSnapshot() {
    this.projectDetails.clientData.projectName = this.snapshotProjectName;
    this.projectDetails.clientData.projectNumber = this.snapshotProjectNumber;
    this.projectDetails.clientData.projectNameErp = this.snapshotProjectNameErp;
    this.directOrder = this.snapshotDirectOrder;
    this.branch = this.snapshotBranch;
    this.projectTypeId = this.snapshotProjectTypeId;
    this.projectStartDate = this.snapshotProjectStartDate;
    this.userManuallyEditedProjectName = false;
  }

  onEnterEditMode() {
    this.isEditMode = true;
    this.takeSnapshot();
  }

  async onCancelEdit() {
    if (this.hasUnsavedChanges) {
      const result = await this.confirmationDialogComponent.show({
        title: this.$t("common.confirmationDialog.unsavedChangesTitle").toString(),
        message: this.$t("common.confirmationDialog.unsavedChangesMessage").toString(),
        rejectMessage: this.$t("common.back").toString(),
        acceptMessage: this.$t("common.abort").toString(),
      });

      if (!result) {
        return;
      }
    }

    this.restoreSnapshot();
    this.isShowing = false;
    this.resolve && this.resolve(undefined);
  }

  async onAccept() {
    const hasEnteredProjectNumber =
      this.projectDetails.clientData.projectNumber !== "";

    if (this.projectStartDate) {
      this.projectDetails.clientData.projectStartDate = this.projectStartDate;
    }
    
    if (
      this.projectDetails.clientData.projectApproval?.approvalResult ===
      ApprovalResult.APPROVED
    ) {
      await this.saveInput(hasEnteredProjectNumber, false);
    } else if (
      !this.allowedToEditProjectNumberOffice ||
      hasEnteredProjectNumber
    ) {
      if (!this.isExternalSystem) {
        this.projectDetails.clientData.projectApproval = {
          recordInfo: getRecordInfo(),
          /* approvalResult: hasEnteredProjectNumber
            ? ApprovalResult.APPROVED
            : ApprovalResult.PENDING, */
          approvalResult: ApprovalResult.APPROVED
        };
      }

      await this.saveInput(hasEnteredProjectNumber, false);
    } else {
      if (!this.isExternalSystem) {
        const didApproveProject = await this.confirmationDialogComponent.show({
          title: this.$t(
            "clientData.missingProjectNumberOfficeTitle"
          ).toString(),
          message: this.$t(
            "clientData.missingProjectNumberOfficeMessage"
          ).toString(),
          acceptMessage: this.$t("common.yes").toString(),
          rejectMessage: this.$t("common.no").toString(),
          compact: false,
        });

        this.projectDetails.clientData.projectApproval = {
          recordInfo: getRecordInfo(),
          approvalResult: didApproveProject
            ? ApprovalResult.APPROVED
            : ApprovalResult.PENDING,
        };
      }

      await this.saveInput(hasEnteredProjectNumber, false);
    }
  }

  async onProjectApprovalDecision(wasApproved: boolean) {
    this.projectDetails.clientData.projectApproval = {
      recordInfo: getRecordInfo(),
      approvalResult: wasApproved
        ? ApprovalResult.APPROVED
        : ApprovalResult.REJECTED,
    };

    await this.saveInput(false, false);
  }

  async saveInput(
    hasEnteredProjectNumber: boolean,
    hasEnteredProjectName: boolean
  ) {
    const projectNumberAlreadyExists =
      hasEnteredProjectNumber &&
      (await doesOtherProjectWithProjectNumberExist(this.projectDetails));

    if (projectNumberAlreadyExists) {
      this.projectNumberErrorMsg = this.$t(
        "projectDetails.projectNumberAlreadyExists"
      ).toString();
      this.showProjectNumberError = true;

      return;
    }

    const projectNameAlreadyExists =
      hasEnteredProjectName &&
      (await doesOtherProjectWithProjectNameExist(this.projectDetails));

    if (projectNameAlreadyExists) {
      const didConfirm = await this.confirmationDialogComponent.show({
        title: this.$t(
          "projectDetails.projectNameAlreadyExistsTitle"
        ).toString(),
        message: this.$t(
          "projectDetails.projectNameAlreadyExistsMessage"
        ).toString(),
      });

      if (didConfirm) {
        this.onSaveProjectDetails();
      }

      return;
    }

    this.onSaveProjectDetails();
  }

  async onSaveProjectDetails() {
    const projectScope = [];
    
    let showConfirmation = false;
    let title = "";
    let message = "";
    let initialProjectTypeId = this.initialProjectTypeId;

    const selectedProjectType = this.projectTypes.find((type) => type.projectTypeId === this.projectTypeId);

    if (!this.projectTypeId || !selectedProjectType) {
      // TODO: Show error
      return;
    }

    if (selectedProjectType) {
      this.projectDetails.visibilityRestrictions = [];
      this.projectDetails.extendedVisibilityRestrictions = [];

      const allowedPlatforms = selectedProjectType.platforms;

      if (allowedPlatforms.includes(ProjectOperationSource.PORTAL)) {
        this.projectDetails.visibilityRestrictions.push(VisibilityRestriction.WEBSITE_ONLY);
        this.projectDetails.extendedVisibilityRestrictions.push(ExtendedVisibilityRestriction.WEBSITE_ONLY);
      }
      if (allowedPlatforms.includes(ProjectOperationSource.DEVICE_MANAGER_APP)) {
        this.projectDetails.extendedVisibilityRestrictions.push(ExtendedVisibilityRestriction.WORK_APP_ONLY);
      }

      const projectPhases = selectedProjectType.projectScope;

      if (projectPhases.includes(ExtendedProjectType.DRYING)) {
        projectScope.push(ProjectType.DRYING);
      }
      if (projectPhases.includes(ExtendedProjectType.LEAK_DETECTION)) {
        projectScope.push(ProjectType.LEAK_DETECTION);
      }

      this.projectDetails.projectScope = projectScope;
      this.projectDetails.clientData.extendedProjectScope = projectPhases;
      this.projectDetails.clientData.projectTypeId = this.projectTypeId;
    }

    if (!isPortalOnlyProjectTypeId(this.projectTypeId)) {
      if (this.initialProjectTypeId && isPortalOnlyProjectTypeId(this.initialProjectTypeId)) {
        showConfirmation = true;
        title = this.$t(
          "clientData.changingProjectTypeToPortalTitle"
        ).toString();
        message = this.$t(
          "clientData.changingProjectTypeToPortalMessage"
        ).toString();

        initialProjectTypeId = this.projectTypeId;
      }
    }
    else {
      if (this.initialProjectTypeId && !isPortalOnlyProjectTypeId(this.initialProjectTypeId)) {
        showConfirmation = true;
        title = this.$t(
          "clientData.changingProjectTypeToProjectmanagerTitle"
        ).toString();
        message = this.$t(
          "clientData.changingProjectTypeToProjectmanagerMessage"
        ).toString();

        initialProjectTypeId = this.projectTypeId;
      }
    }

    const shouldResetTiles = 
      !this.isNewProject && // Is not a new project
      this.initialProjectTypeId &&
      isDryingOnlyProjectTypeId(this.initialProjectTypeId) && // Initially should only be a Trocknung project
      doesProjectTypeIdHaveLeakDetection(this.projectTypeId); // Changed into project that contains Leckortung

    if (shouldResetTiles) {
      if (this.projectDetails.documentationAndLeakDetectionData) {
        this.projectDetails.documentationAndLeakDetectionData.completedBy = null;
      }

      if (this.projectDetails.damagePatternData) {
        this.projectDetails.damagePatternData.complete = false;
        this.projectDetails.damagePatternData.recordInfo = null;
      }
    }

    this.projectDetails.clientData.directOrder = this.directOrder === "1";
    this.projectDetails.clientData.branch = this.branch;

    if (this.userManuallyEditedProjectName && this.projectDetails.clientData.projectName !== this.initialProjectName) {
      this.projectDetails.clientData.projectNameSource =
        ProjectNameSource.USER_INPUT;
      this.projectDetails.clientData.extendedProjectNameSource =
        ExtendedProjectNameSource.USER_INPUT;
    }

    if (showConfirmation && !this.isNewProject) {
      const confirmChangeProjectType = await this.confirmationDialogComponent.show({
        title: title,
        message: message,
        acceptMessage: this.$t("common.change").toString(),
        rejectMessage: this.$t("common.back").toString(),
        compact: false,
      });

      if (confirmChangeProjectType) {
        this.initialProjectTypeId = initialProjectTypeId;
        this.isShowing = false;

        this.resolve && this.resolve(this.projectDetails);
      }
    }
    else {
      this.initialProjectTypeId = initialProjectTypeId;
      this.isShowing = false;

      this.resolve && this.resolve(this.projectDetails);
    }

  }
}
